// extracted by mini-css-extract-plugin
export default {"realtime":"Realtime_realtime__huXHK","light":"Realtime_light__rfH9d","dark":"Realtime_dark__Zf2vK","realtimeScrollableArea":"Realtime_realtimeScrollableArea__fUyBy"};